import React from "react";

const Uncle = () => {
  return (
    <div>
      <h4>Uncle</h4>
    </div>
  );
};

export default Uncle;
